import { create } from 'zustand'

interface BrandStore {
  selectedBrandId: string | null
  setSelectedBrandId: (brandId: string | null) => void
  clearSelectedBrandId: () => void
}

export const useBrandStore = create<BrandStore>((set) => ({
  selectedBrandId: null,
  setSelectedBrandId: (brandId) => set({ selectedBrandId: brandId }),
  clearSelectedBrandId: () => set({ selectedBrandId: null }),
}))

